(()=> {
  // --- navigation hide-on-scroll (mobile pill + desktop nav) ---
  const navs = document.querySelectorAll('[data-rk-mobile-pill], [data-rk-desktop-nav]');

  if (navs.length) {
    let lastScrollY = window.scrollY;
    const THRESHOLD = 8; // ignore sub-threshold jitter so the nav doesn't flicker
    const setHidden = (hidden) => navs.forEach((nav) => nav.classList.toggle('rk-nav--hidden', hidden));

    window.addEventListener('scroll', () => {
      const currentScrollY = Math.max(0, window.scrollY); // clamp iOS rubber-band overscroll
      const delta = currentScrollY - lastScrollY;
      if (Math.abs(delta) < THRESHOLD) return;
      // Hide on scroll down, show on scroll up; always show near the top
      setHidden(delta > 0 && currentScrollY > 80);
      lastScrollY = currentScrollY;
    }, { passive: true });

    setHidden(false);
  }

  // --- hoverborder grid: desktop CTA ---
  const desktopCta = document.querySelector('[data-rk-cta]');
  if (desktopCta) {
    const grid = desktopCta.querySelector('.rk-cta__grid');
    if (grid) {
      const COLS = 36, ROWS = 12;
      const ripple = document.createElement('div');
      ripple.className = 'rk-cta__ripple';
      for (let i = 0; i < COLS * ROWS; i++) {
        const cell = document.createElement('span');
        cell.className = 'rk-cta__grid-cell';
        // Each cell positions the ripple to where the mouse entered
        const row = Math.floor(i / COLS);
        const col = i % COLS;
        const top  = (0.125 + row * 0.25) + 'em';
        const left = (0.1875 + col * 0.25) + 'em';
        cell.addEventListener('mouseenter', () => {
          ripple.style.top  = top;
          ripple.style.left = left;
        });
        grid.appendChild(cell);
      }
      grid.appendChild(ripple);
    }
  }

  // --- active state: highlight current page in both navs ---
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('[data-rk-route]').forEach(function(link) {
    const route = link.getAttribute('data-rk-route').replace(/\/$/, '') || '/';
    if (route === currentPath) link.classList.add('is-active');
  });

  // --- mobile pill: keep the active (expanded) item in view — the bar can overflow on narrow screens ---
  const pillBar = document.querySelector('.rk-mobile-pill');
  const activeItem = pillBar ? pillBar.querySelector('a.is-active') : null;
  if (activeItem) {
    const centerActive = () => {
      pillBar.scrollLeft = activeItem.offsetLeft - (pillBar.clientWidth - activeItem.offsetWidth) / 2;
    };
    centerActive();
    // re-center once the label expand animation settles on its final width
    const activeLabel = activeItem.querySelector('span:not(.material-symbols-outlined)');
    if (activeLabel) activeLabel.addEventListener('animationend', centerActive, { once: true });
  }

  // --- click ripple: both CTAs ---
  document.querySelectorAll('.rk-float-nav__cta, .rk-mobile-pill__cta').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const rect = btn.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height) * 2;
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top  - size / 2;
      const ripple = document.createElement('span');
      ripple.className = 'rk-cta__click-ripple';
      ripple.style.cssText = `width:${size}px;height:${size}px;left:${x}px;top:${y}px`;
      btn.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove());
    });
  });

  // --- parent active state: the Platform entry lights up on any of its child pages ---
  document.querySelectorAll('[data-rk-parent-routes]').forEach(function(el) {
    const routes = el.getAttribute('data-rk-parent-routes')
      .split(',')
      .map((route) => route.trim().replace(/\/$/, ''));
    if (routes.includes(currentPath)) el.classList.add('is-active');
  });

  // --- desktop suite panel ---
  const suiteTrigger = document.querySelector('[data-rk-suite-trigger]');
  const suitePanel   = document.querySelector('[data-rk-suite-panel]');
  const desktopNav   = document.querySelector('[data-rk-desktop-nav]');

  if (suiteTrigger && suitePanel && desktopNav) {
    const CLOSE_DELAY = 160;   // grace period while the pointer crosses the gap
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let hoverTimer = null;
    let hideTimer = null;

    const isOpen = () => suiteTrigger.getAttribute('aria-expanded') === 'true';

    const openSuite = () => {
      clearTimeout(hoverTimer);
      clearTimeout(hideTimer);
      if (isOpen()) return;
      // anchor the panel to the live bottom edge of the bar, not to a guessed height
      suitePanel.style.setProperty('--rk-suite-top', desktopNav.getBoundingClientRect().bottom + 'px');
      suitePanel.hidden = false;
      void suitePanel.offsetWidth; // flush layout so the transition has a start state
      suitePanel.classList.add('is-open');
      suiteTrigger.setAttribute('aria-expanded', 'true');
    };

    const closeSuite = () => {
      clearTimeout(hoverTimer);
      if (!isOpen()) return;
      suitePanel.classList.remove('is-open');
      suiteTrigger.setAttribute('aria-expanded', 'false');
      hideTimer = setTimeout(() => {
        if (!isOpen()) suitePanel.hidden = true;
      }, 300);
    };

    suiteTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      isOpen() ? closeSuite() : openSuite();
    });

    if (canHover.matches) {
      [suiteTrigger, suitePanel].forEach((el) => {
        el.addEventListener('mouseenter', openSuite);
        el.addEventListener('mouseleave', () => {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(closeSuite, CLOSE_DELAY);
        });
      });
    }

    // a hash link inside the panel navigates without a reload, so close it by hand
    suitePanel.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeSuite));

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !isOpen()) return;
      closeSuite();
      suiteTrigger.focus();
    });

    document.addEventListener('click', (e) => {
      if (!isOpen()) return;
      if (suitePanel.contains(e.target) || suiteTrigger.contains(e.target)) return;
      closeSuite();
    });

    document.addEventListener('focusin', (e) => {
      if (!isOpen()) return;
      if (suitePanel.contains(e.target) || suiteTrigger.contains(e.target)) return;
      closeSuite();
    });

    // the bar slides away on scroll, so the panel must not stay behind on its own
    window.addEventListener('scroll', () => { if (isOpen()) closeSuite(); }, { passive: true });
    window.addEventListener('resize', () => { if (isOpen()) closeSuite(); }, { passive: true });
  }

  // --- mobile suite sheet ---
  const sheetTrigger = document.querySelector('[data-rk-sheet-trigger]');
  const sheet        = document.querySelector('[data-rk-sheet]');

  if (sheetTrigger && sheet) {
    const sheetIsOpen = () => sheetTrigger.getAttribute('aria-expanded') === 'true';
    let sheetHideTimer = null;

    const openSheet = () => {
      clearTimeout(sheetHideTimer);
      sheet.hidden = false;
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      sheetTrigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };

    const closeSheet = () => {
      if (!sheetIsOpen()) return;
      sheet.classList.remove('is-open');
      sheetTrigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      sheetHideTimer = setTimeout(() => {
        if (!sheetIsOpen()) sheet.hidden = true;
      }, 320);
    };

    sheetTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      sheetIsOpen() ? closeSheet() : openSheet();
    });

    sheet.querySelectorAll('[data-rk-sheet-close]').forEach((el) => el.addEventListener('click', closeSheet));
    sheet.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeSheet));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sheetIsOpen()) closeSheet();
    });
  }
})();